import { styled } from '@mui/system';
import NotificationsActiveRoundedIcon from '@mui/icons-material/NotificationsActiveRounded';
import NotificationsPausedRoundedIcon from '@mui/icons-material/NotificationsPausedRounded';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { green } from '@mui/material/colors';

export const GreenFiberIcon = styled(FiberManualRecordIcon)(() => ({
  color: green[600],
  padding: 3
}));

export const RedNotificationsActiveRoundedIcon = styled(NotificationsActiveRoundedIcon)({
  color: '#f44336'
});

export const RedNotificationsActiveIcon = styled(NotificationsActiveIcon)({
  color: '#f44336'
});

export const GreyNotificationsPausedIcon = styled(NotificationsPausedRoundedIcon)(({ theme }) => ({
  color: theme.palette.grey[600]
}));

export const GreyFiberIcon = styled(FiberManualRecordIcon)(({ theme }) => ({
  color: theme.palette.grey[600]
}));
